<ng-container *ngIf="loading$ | async">
  <app-spinner />
</ng-container>
